import { Remarkable } from 'remarkable';
import { useEffect, useState } from 'react';
import Link from 'next/link';


export default function Blog({ blogs }) {

  const blogsortByDateCreated = blogs.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });
  const blogFiltered = blogsortByDateCreated.filter((data) => {
    return data
  })
  const [blogsFetched, setBlogsFetched] = useState(blogFiltered.slice(0, 3));

  useEffect(() => {
    const md = new Remarkable();
    const blogsFetched = blogFiltered.slice(0, 3);
    function readingTime(text) {
      const wpm = 265; //same as medium article
      const words = text.trim().split(/\s+/).length;
      const time = Math.ceil(words / wpm);
      return time;
    }

    const updatedBlogs = blogsFetched.map((blog) => {
      const div = document.createElement('div');
      div.innerHTML = md.render(blog.source);
      const time = readingTime(div.innerText);
      return { ...blog, readingTime: `${time} min read` };
    });
    setBlogsFetched(updatedBlogs);
  }, []);

  return (
    <div className="bg-white py-24 sm:py-32 font-['Inter']">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <Link href="/blog">
            <h2 className="medium-title hover:cursor-pointer hover:text-orange-400 transition ease-in-out">Recent on the blog</h2>
          </Link>
          {/* <p className="mt-2 text-lg leading-8 text-gray-600">
            Learn how to grow your business with our expert advice.
          </p> */}
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-6-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {blogsFetched.map((post) => (
            <article key={post.urlPath} className="flex flex-col items-start justify-between">
              <div className="relative w-full" tabIndex={0}>
                <img
                  src={`${post?.image ? post.image : "/assets/images/layout/datopian-logo-black.png"}`}
                  alt="Blog Post"
                  className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div className="max-w-xl">
                <div className="mt-8 flex items-center gap-x-4 text-xs" tabIndex={0}>
                  <span className="text-gray-500">
                    {post?.readingTime ? post.readingTime : "0 min read"}
                  </span>
                  <Link href="/blog" className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100" >
                    {post.categories[0]}
                  </Link>
                </div>
                <div className="group relative" tabIndex={0}>
                  <h3 className="mt-3 text-lg font-bold text-gray-900 group-hover:text-gray-600 line-clamp-1">
                    <a href={`../${post.urlPath}`}>
                      <span className="absolute inset-0" />
                      {post.title}
                    </a>
                  </h3>
                  <p className="mt-5 line-clamp-3  body-text">{post.description}</p>
                </div>
                <div className="relative mt-8 flex items-center gap-x-2 text-start ">
                  <div className="flex -space-x-4">
                    {post.avatarUrl.map((avatar) => (
                      <img key={avatar} src={avatar} alt="Author Image" className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover object-cover" />
                    ))}
                  </div>
                  <div className="flex flex-row items-center gap-2">
                    <div className="text-sm leading-6 flex flex-col">
                      {post.authors.map((author, index) => (
                        <p className="font-semibold text-maingray flex flex-nowrap" key={author}>
                          {author}
                          {index !== post.authors.length - 1 && <>,&nbsp;</>}
                        </p>
                      )
                      )}
                    </div>
                    <time dateTime={post.created} className="text-secgray text-xs">
                      {new Date(post.created).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </time>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
